const initialPaging = {
  page: 1,
  sizePerPage: 10,
  sortField: '',
  sortOrder: '',
};

const initialFields = {
  includedTeam: 'true',
  keywords: '',
  stage: 'nb',
  stageOptions: '',
  receivedFrom: '',
  receivedTo: '',
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'submit':
      return {
        ...state,
        paging: initialPaging,
        queryParams: {
          ...state.queryParams,
          ...state.fields,
          ...initialPaging,
        },
      };
    case 'changeProducer':
      return {
        paging: initialPaging,
        fields: initialFields,
        queryParams: {
          ...initialPaging,
          ...initialFields,
          ...action.payload,
        },
      };
    case 'changePaging':
      return {
        ...state,
        paging: {...state.paging, ...action.payload},
        queryParams: {
          ...state.queryParams,
          ...action.payload,
        },
      };
    case 'changeFields':
      return {
        ...state,
        fields: {
          ...state.fields,
          ...action.payload,
        },
      };
    default:
      throw new Error();
  }
};

export const getInitialState = producer => ({
  paging: initialPaging,
  fields: initialFields,
  queryParams: {
    ...initialPaging,
    ...initialFields,
    manager: producer.producerFullName,
    selectedProducerId: producer.producerId,
  },
});

export default reducer;
export {initialFields};
